import { useMemo } from "react";
import { formatYmd, todayYmd } from "../../features/cases/dates";

const MAX_ITEMS = 60;

const weekdayFormat = new Intl.DateTimeFormat("el-GR", { weekday: "long" });

const dateHeading = (ymd) => {
  const date = new Date(Math.floor(ymd / 10000), Math.floor((ymd % 10000) / 100) - 1, ymd % 100);
  const weekday = weekdayFormat.format(date);
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}, ${formatYmd(ymd)}`;
};

// Overview pane for the desktop case tables (shown while no case is open):
// a few counters and the upcoming dates of the (filtered) rows, grouped by
// day. `getEvents(row)` returns [{ ymd, kind }] — e.g. hearings, auctions;
// `getLabel(row)` returns { primary, secondary }.
const UpcomingOverview = ({
  rows,
  getEvents,
  getLabel,
  onOpen,
  stats = [],
  title = "Επερχόμενες ημερομηνίες",
  emptyText = "Δεν υπάρχουν επερχόμενες ημερομηνίες.",
}) => {
  const groups = useMemo(() => {
    const today = todayYmd();
    const events = [];
    rows.forEach((row) => {
      (getEvents(row) || []).forEach((event) => {
        if (event?.ymd >= today) events.push({ ...event, row });
      });
    });
    events.sort((a, b) => a.ymd - b.ymd);
    const byDay = new Map();
    events.slice(0, MAX_ITEMS).forEach((event) => {
      if (!byDay.has(event.ymd)) byDay.set(event.ymd, []);
      byDay.get(event.ymd).push(event);
    });
    return [...byDay.entries()];
  }, [rows, getEvents]);

  return (
    <div className="ds-upcoming">
      {stats.length > 0 && (
        <div className="ds-stats">
          {stats.map((stat) => (
            <div key={stat.label} className="ds-stat">
              <span className="ds-stat-value">{stat.value}</span>
              <span className="ds-stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      )}
      <section className="ds-card">
        <h2 className="ds-card-title">{title}</h2>
        {groups.length === 0 ? (
          <p className="ds-muted ds-card-empty">{emptyText}</p>
        ) : (
          groups.map(([ymd, events]) => (
            <div key={ymd} className="ds-upcoming-day">
              <h3 className="ds-upcoming-date">{dateHeading(ymd)}</h3>
              <ul>
                {events.map((event, i) => {
                  const { primary, secondary } = getLabel(event.row);
                  return (
                    <li key={`${event.row.id}-${i}`}>
                      <button
                        type="button"
                        className="ds-upcoming-item"
                        onClick={() => onOpen(event.row.id)}
                      >
                        <span className="ds-upcoming-primary">{primary}</span>
                        {secondary && (
                          <span className="ds-upcoming-secondary">{secondary}</span>
                        )}
                        {event.kind && <span className="ds-badge ds-badge--info">{event.kind}</span>}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))
        )}
      </section>
    </div>
  );
};

export default UpcomingOverview;
